import { render, staticRenderFns } from "./DictionarySimpleTable.vue?vue&type=template&id=96e4e6a2&"
import script from "./DictionarySimpleTable.vue?vue&type=script&lang=js&"
export * from "./DictionarySimpleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports